export default [
    { name: "Grams", short: "g", g: 1 },
    { name: "Ml", short: "ml", g: 1 },
    { name: "Ounce", short: "oz", g: 28.34952 },
    { name: "Pound", short: "lb", g: 453.59237 },
    { name: "Fluid Ounce", short: "fl oz", g: 29.5735296875 },
]
